const centerIntroRoutes = [
  {
    path: "centerIntro",
    redirect: { path: "/centerIntro/greeting" },
    meta: {
      title: "센터소개",
      titleEn: "Center Intro",
      menuCd: "CENTER_GREETING",
    },
    children: [
      {
        path: "greeting", // centerIntro/greeting
        meta: {
          title: "인사말",
          titleEn: "Greeting",
          isDynamic: true,
          menuCd: "CENTER_GREETING",
        },
        component: () => import("@/views/centerIntro/CenterGreeting.vue"),
      },
      {
        path: "visionSystem", // centerIntro/visionSystem
        meta: {
          title: "비전체계도",
          titleEn: "Vision System",
          isDynamic: true,
          menuCd: "CENTER_VISTION",
        },
        component: () => import("@/views/centerIntro/CenterVisionSystem.vue"),
      },
      {
        path: "organization", // centerIntro/organization
        meta: {
          title: "조직도",
          titleEn: "Organization",
          isDynamic: true,
          menuCd: "CENTER_ORGANIZATION",
        },
        component: () => import("@/views/centerIntro/CenterOrganization.vue"),
      },
      {
        path: "directions", // centerIntro/directions
        meta: {
          title: "센터위치",
          titleEn: "Directions",
          isDynamic: true,
          menuCd: "CENTER_DIRECTIONS",
        },
        component: () => import("@/views/centerIntro/CenterDirections.vue"),
      },
    ],
  },
];
export default centerIntroRoutes;
